module.exports = __webpack_public_path__ + "img/reset.678605f6.svg";